/* =====================================================================
   STARTUS CLOUD — Pre-Built PCs (sc-prebuilt.js)
   Paired with sections/sc-prebuilt-grid.liquid.

   Everything here is progressive enhancement. The cards, prices, spec sheets
   and the buy form are all rendered by Liquid and work with JavaScript off —
   this file adds filtering, sorting, the spec dialog, side-by-side compare and
   an AJAX add-to-cart on top of them.
   ===================================================================== */
(function () {
  'use strict';

  var SC = (window.SC = window.SC || {});
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  var MAX_COMPARE = 3;

  function Prebuilt(root) {
    this.root = root;
    this.cards = $$('[data-pb-card]', root);
    if (!this.cards.length) return;

    this.grid    = $('[data-pb-grid]', root);
    this.count   = $('[data-pb-count]', root);
    this.empty   = $('[data-pb-empty]', root);
    this.clear   = $('[data-pb-clear]', root);
    this.sortSel = $('[data-pb-sort]', root);
    this.scrim   = $('[data-pb-scrim]', root);

    this.state = { use: '', budget: [], res: [], brand: [], sort: 'featured' };
    this.compare = [];
    this.lastFocus = null;

    // Remember the authored order so "Featured" can always be restored.
    this.cards.forEach(function (c, i) { c.dataset.pbOrder = i; });

    this.readUrl();
    this.bind();
    this.apply();
  }

  /* ─────────────────────────────────────────────────────── filtering ── */

  Prebuilt.prototype.matches = function (card) {
    var s = this.state;
    if (s.use && card.dataset.use !== s.use) return false;
    if (s.res.length && s.res.indexOf(card.dataset.res) === -1) return false;
    if (s.brand.length && s.brand.indexOf(card.dataset.brand) === -1) return false;
    if (s.budget.length) {
      var price = parseFloat(card.dataset.price) || 0;
      var hit = s.budget.some(function (band) {
        var bits = String(band).split(':');
        var min = parseFloat(bits[0]) || 0;
        var max = bits[1] === '' || bits[1] == null ? Infinity : parseFloat(bits[1]);
        return price >= min && price < max;
      });
      if (!hit) return false;
    }
    return true;
  };

  Prebuilt.prototype.apply = function () {
    var self = this, shown = 0;

    this.cards.forEach(function (card) {
      var on = self.matches(card);
      card.classList.toggle('is-hidden', !on);
      if (on) shown++;
    });

    // Sort by moving nodes rather than re-rendering, so the server-rendered
    // markup (and anything focused inside it) survives.
    var order = this.cards.slice();
    var s = this.state.sort;
    order.sort(function (a, b) {
      // Sold-out machines always sink, whatever the sort.
      var aa = a.dataset.available === 'true', ba = b.dataset.available === 'true';
      if (aa !== ba) return aa ? -1 : 1;
      if (s === 'price-asc')  return (+a.dataset.price) - (+b.dataset.price);
      if (s === 'price-desc') return (+b.dataset.price) - (+a.dataset.price);
      if (s === 'name')       return a.dataset.name.localeCompare(b.dataset.name);
      return (+a.dataset.pbOrder) - (+b.dataset.pbOrder);
    });
    order.forEach(function (c) { self.grid.appendChild(c); });

    if (this.count) this.count.textContent = shown + (shown === 1 ? ' build' : ' builds');
    if (this.empty) this.empty.hidden = shown > 0;
    if (this.grid)  this.grid.hidden = shown === 0;

    var dirty = !!(this.state.use || this.state.budget.length || this.state.res.length || this.state.brand.length);
    if (this.clear) this.clear.hidden = !dirty;

    this.writeUrl();
  };

  Prebuilt.prototype.toggleIn = function (key, value) {
    var list = this.state[key];
    var at = list.indexOf(value);
    if (at > -1) list.splice(at, 1); else list.push(value);
  };

  Prebuilt.prototype.reset = function () {
    this.state.use = ''; this.state.budget = []; this.state.res = []; this.state.brand = [];
    $$('[data-pb-budget],[data-pb-res],[data-pb-brand]', this.root).forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
    });
    $$('[data-pb-use]', this.root).forEach(function (t, i) {
      t.classList.toggle('is-on', i === 0);
      t.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
    });
    this.apply();
  };

  /* ───────────────────────────────────────────── shareable filters ── */

  Prebuilt.prototype.writeUrl = function () {
    if (!window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href), s = this.state;
    var set = function (k, v) { v && v.length ? url.searchParams.set(k, v) : url.searchParams.delete(k); };
    set('use', s.use);
    set('budget', s.budget.join('~'));
    set('res', s.res.join('~'));
    set('brand', s.brand.join('~'));
    set('sort', s.sort === 'featured' ? '' : s.sort);
    window.history.replaceState({}, '', url.toString());
  };

  Prebuilt.prototype.readUrl = function () {
    var q = new URL(window.location.href).searchParams, self = this;
    var list = function (k) { var v = q.get(k); return v ? v.split('~').filter(Boolean) : []; };
    this.state.use    = q.get('use') || '';
    this.state.budget = list('budget');
    this.state.res    = list('res');
    this.state.brand  = list('brand');
    this.state.sort   = q.get('sort') || 'featured';
    if (this.sortSel) this.sortSel.value = this.state.sort;

    // Reflect the restored state back onto the controls.
    $$('[data-pb-use]', this.root).forEach(function (t) {
      var on = t.getAttribute('data-pb-use') === self.state.use;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    [['budget', 'data-pb-budget'], ['res', 'data-pb-res'], ['brand', 'data-pb-brand']].forEach(function (pair) {
      $$('[' + pair[1] + ']', self.root).forEach(function (b) {
        var on = self.state[pair[0]].indexOf(b.getAttribute(pair[1])) > -1;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  };

  /* ──────────────────────────────────────────────────────── dialogs ── */

  Prebuilt.prototype.openDialog = function (node) {
    this.lastFocus = document.activeElement;
    node.hidden = false;
    if (this.scrim) this.scrim.hidden = false;
    document.body.style.overflow = 'hidden';
    this.openNode = node;
    var focusable = node.querySelector('[data-pb-sheet-close],[data-pb-compare-close],button,a');
    if (focusable) focusable.focus();
  };

  Prebuilt.prototype.closeDialog = function () {
    if (!this.openNode) return;
    this.openNode.hidden = true;
    this.openNode = null;
    if (this.scrim) this.scrim.hidden = true;
    document.body.style.overflow = '';
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  /* Keep Tab inside an open dialog — without this the shopper tabs into the
     page behind the scrim and cannot see where the focus went. */
  Prebuilt.prototype.trap = function (e) {
    if (!this.openNode || e.key !== 'Tab') return;
    var f = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', this.openNode)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  /* ──────────────────────────────────────────────────────── compare ── */

  Prebuilt.prototype.cardByHandle = function (h) {
    return this.cards.filter(function (c) { return c.dataset.handle === h; })[0];
  };

  Prebuilt.prototype.syncCompare = function () {
    var bar = $('[data-pb-compare-bar]', this.root);
    var items = $('[data-pb-compare-items]', this.root);
    var countEl = $('[data-pb-compare-count]', this.root);
    if (!bar) return;

    bar.hidden = this.compare.length === 0;
    if (countEl) countEl.textContent = this.compare.length;

    var self = this;
    items.innerHTML = this.compare.map(function (h) {
      var card = self.cardByHandle(h);
      if (!card) return '';
      var img = card.querySelector('.pb-card-media img');
      var name = card.querySelector('.pb-card-title').textContent.trim();
      return '<span class="pb-compare-pill">' +
        (img ? '<img src="' + esc(img.getAttribute('src')) + '" alt="" width="26" height="26">' : '') +
        esc(name) +
        '<button type="button" data-pb-compare-remove="' + esc(h) + '" aria-label="Remove ' + esc(name) + ' from comparison">' +
        '<svg class="ic ic-14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button></span>';
    }).join('');
  };

  Prebuilt.prototype.buildCompareTable = function () {
    var self = this;
    var picked = this.compare.map(function (h) { return self.cardByHandle(h); }).filter(Boolean);
    if (picked.length < 2) {
      return '<p class="sm" style="padding:18px 0;color:var(--ink-4)">Pick at least two builds to compare.</p>';
    }

    // Spec labels come from the server-rendered sheets, so the comparison can
    // never list a row the spec sheet does not have.
    var labels = [];
    picked.forEach(function (card) {
      $$('.pb-sheet-row th', card).forEach(function (th) {
        var t = th.textContent.trim();
        if (t && labels.indexOf(t) === -1) labels.push(t);
      });
    });

    var valueFor = function (card, label) {
      var hit = $$('.pb-sheet-row', card).filter(function (tr) {
        var th = tr.querySelector('th');
        return th && th.textContent.trim() === label;
      })[0];
      return hit ? hit.querySelector('td').textContent.trim() : '—';
    };

    var prices = picked.map(function (c) { return parseFloat(c.dataset.price) || 0; });
    var cheapest = Math.min.apply(null, prices);

    var h = '<table class="pb-compare-table"><thead><tr><th></th>';
    picked.forEach(function (card, i) {
      var img = card.querySelector('.pb-card-media img');
      var name = card.querySelector('.pb-card-title').textContent.trim();
      var price = card.querySelector('.pb-card-price b').textContent.trim();
      var href = card.querySelector('.pb-card-title a').getAttribute('href');
      h += '<th><span class="pb-compare-head">' +
           (img ? '<img src="' + esc(img.getAttribute('src')) + '" alt="" loading="lazy">' : '') +
           '<b>' + esc(name) + '</b><span>' + esc(price) + '</span>' +
           '<a class="btn btn-primary btn-sm" href="' + esc(href) + '">View</a>' +
           '</span></th>';
    });
    h += '</tr></thead><tbody>';
    h += '<tr><th scope="row">Price</th>';
    picked.forEach(function (card, i) {
      h += '<td class="' + (prices[i] === cheapest && picked.length > 1 ? 'is-best' : '') + '">' +
           esc(card.querySelector('.pb-card-price b').textContent.trim()) +
           (prices[i] === cheapest ? ' · lowest' : '') + '</td>';
    });
    h += '</tr>';
    labels.forEach(function (label) {
      var vals = picked.map(function (c) { return valueFor(c, label); });
      var allSame = vals.every(function (v) { return v === vals[0]; });
      h += '<tr><th scope="row">' + esc(label) + '</th>';
      vals.forEach(function (v) {
        h += '<td' + (allSame ? ' style="color:var(--ink-4)"' : '') + '>' + esc(v) + '</td>';
      });
      h += '</tr>';
    });
    h += '</tbody></table>';
    return h;
  };

  /* ─────────────────────────────────────────────────────────── cart ── */

  Prebuilt.prototype.addToCart = function (variantId, btn) {
    if (!variantId || btn.dataset.busy) return;
    var original = btn.innerHTML;
    btn.dataset.busy = '1';
    btn.disabled = true;
    btn.textContent = 'Adding…';

    var url = (window.Shopify && Shopify.routes && Shopify.routes.cart_add_url)
      ? Shopify.routes.cart_add_url + '.js' : '/cart/add.js';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ['cart-count-badge', 'offcanvas-cart'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (r) {
        if (!r.ok) throw r.data;
        SC.refreshCartSections ? SC.refreshCartSections(r.data.sections) : refreshCart(r.data.sections);
        var oc = document.getElementById('offcanvas-cart');
        if (oc && window.bootstrap && window.bootstrap.Offcanvas) {
          window.bootstrap.Offcanvas.getOrCreateInstance(oc).show();
        }
        btn.textContent = 'Added to cart';
        setTimeout(function () { btn.innerHTML = original; btn.disabled = false; delete btn.dataset.busy; }, 1600);
      })
      .catch(function (err) {
        // Never leave the shopper stuck: fall back to the real form/product page.
        console.error('[sc-prebuilt] cart add failed', err);
        btn.innerHTML = original;
        btn.disabled = false;
        delete btn.dataset.busy;
        var form = btn.closest('form');
        if (form) form.submit();
      });
  };

  function refreshCart(sections) {
    var kt = document.querySelector('kt-cart');
    if (kt && typeof kt.reloadCartElements === 'function') { kt.reloadCartElements(sections); return; }
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      if (id === 'cart-count-badge') {
        var b = doc.querySelector('.cart-count-badge');
        if (b) $$('.cart-count-badge').forEach(function (n) { n.replaceWith(b.cloneNode(true)); });
      } else if (id === 'offcanvas-cart') {
        var c = doc.querySelector('.cart-container');
        if (c) $$('.cart-container').forEach(function (n) { n.replaceWith(c.cloneNode(true)); });
      }
    });
  }

  /* ───────────────────────────────────────────────────────── events ── */

  Prebuilt.prototype.bind = function () {
    var self = this, root = this.root;

    root.addEventListener('click', function (e) {
      var t = e.target;

      var tab = t.closest('[data-pb-use]');
      if (tab) {
        self.state.use = tab.getAttribute('data-pb-use');
        $$('[data-pb-use]', root).forEach(function (x) {
          var on = x === tab;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        self.apply();
        return;
      }

      var chip = t.closest('[data-pb-budget],[data-pb-res],[data-pb-brand]');
      if (chip) {
        var key = chip.hasAttribute('data-pb-budget') ? 'budget'
                : chip.hasAttribute('data-pb-res') ? 'res' : 'brand';
        var attr = 'data-pb-' + key;
        self.toggleIn(key, chip.getAttribute(attr));
        chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        self.apply();
        return;
      }

      if (t.closest('[data-pb-clear]') || t.closest('[data-pb-clear-2]')) { self.reset(); return; }

      var openSheet = t.closest('[data-pb-sheet-open]');
      if (openSheet) {
        var node = $('#pb-sheet-' + CSS.escape(openSheet.getAttribute('data-pb-sheet-open')), root);
        if (node) self.openDialog(node);
        return;
      }

      if (t.closest('[data-pb-sheet-close]') || t.closest('[data-pb-scrim]') ||
          t.closest('[data-pb-compare-close]')) { self.closeDialog(); return; }

      var sheetBuy = t.closest('[data-pb-sheet-buy]');
      if (sheetBuy) { self.addToCart(sheetBuy.getAttribute('data-pb-sheet-buy'), sheetBuy); return; }

      var rm = t.closest('[data-pb-compare-remove]');
      if (rm) {
        var h = rm.getAttribute('data-pb-compare-remove');
        self.compare = self.compare.filter(function (x) { return x !== h; });
        var box = self.cardByHandle(h);
        if (box) { var cb = box.querySelector('[data-pb-compare]'); if (cb) cb.checked = false; }
        self.syncCompare();
        return;
      }

      if (t.closest('[data-pb-compare-clear]')) {
        self.compare = [];
        $$('[data-pb-compare]', root).forEach(function (c) { c.checked = false; });
        self.syncCompare();
        return;
      }

      if (t.closest('[data-pb-compare-open]')) {
        var modal = $('[data-pb-compare-modal]', root);
        $('[data-pb-compare-body]', root).innerHTML = self.buildCompareTable();
        self.openDialog(modal);
        return;
      }
    });

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-pb-sort]')) { self.state.sort = e.target.value; self.apply(); return; }

      if (e.target.matches('[data-pb-compare]')) {
        var h = e.target.value;
        if (e.target.checked) {
          if (self.compare.length >= MAX_COMPARE) {
            e.target.checked = false;
            var first = self.compare[0];
            // Politely explain rather than silently ignoring the click.
            var bar = $('[data-pb-compare-bar]', root);
            if (bar) {
              bar.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-6px)' }, { transform: 'translateY(0)' }],
                          { duration: 260 });
            }
            return;
          }
          self.compare.push(h);
        } else {
          self.compare = self.compare.filter(function (x) { return x !== h; });
        }
        self.syncCompare();
      }
    });

    // AJAX the buy form, but leave the real POST as the fallback path.
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-pb-buy]');
      if (!form) return;
      var id = form.querySelector('input[name="id"]');
      var btn = form.querySelector('button[type="submit"]');
      if (!id || !btn) return;
      e.preventDefault();
      self.addToCart(id.value, btn);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeDialog();
      self.trap(e);
    });
  };

  /* ─────────────────────────────────────────────────────────── boot ── */

  function boot(scope) {
    $$('[data-sc-prebuilt]', scope || document).forEach(function (el) {
      if (el.__scPrebuilt) return;
      el.__scPrebuilt = new Prebuilt(el);
    });
  }

  SC.Prebuilt = Prebuilt;
  SC.initPrebuilt = boot;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);

  document.addEventListener('shopify:section:load', function (e) {
    var host = e.target && e.target.querySelector('[data-sc-prebuilt]');
    if (host) { host.__scPrebuilt = null; boot(e.target); }
  });
})();
